import { WIDGET_CONTAINER_SELECTOR } from "../../constants";

export const copyText = async ({ text }: { text: string }) => {
  const activeElement = document.activeElement as HTMLElement;
  const hiddenTextArea = document.createElement("textarea");
  // Trim the text to remove any trailing or leading whitespace
  hiddenTextArea.value = text.trim();

  const widgetContainerElement = document.querySelector(
    WIDGET_CONTAINER_SELECTOR
  );
  const widgetContainer = widgetContainerElement || document.body;
  widgetContainer.appendChild(hiddenTextArea);

  if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
    const editable = hiddenTextArea.contentEditable;
    const readOnly = hiddenTextArea.readOnly;
    hiddenTextArea.contentEditable = "true";
    hiddenTextArea.readOnly = true;
    hiddenTextArea.focus();

    const range = document.createRange();
    range.selectNodeContents(hiddenTextArea);

    const selection = window.getSelection();
    if (selection) {
      selection.removeAllRanges();
      selection.addRange(range);
    }

    hiddenTextArea.setSelectionRange(0, 999999);
    hiddenTextArea.contentEditable = editable;
    hiddenTextArea.readOnly = readOnly;
  }

  try {
    if (navigator.clipboard) {
      // Use the Clipboard API directly with the trimmed value
      await navigator.clipboard.writeText(text.trim());
    } else {
      if (!navigator.userAgent.match(/ipad|ipod|iphone/i)) {
        hiddenTextArea.focus();
        hiddenTextArea.select();

        if (activeElement) {
          activeElement.focus(); // restore focus after copy
        }
      }

      const success = document.execCommand("copy");
      if (!success) {
        throw new Error("Copy command failed");
      }
    }
  } catch (err) {
    console.error("Unable to copy text to clipboard: ", err);
  }

  widgetContainer.removeChild(hiddenTextArea);
};
